import { ApiBase } from "../../base/_ApiBase";
import { CollectionTypeModel } from "../../models/collections/CollectionTypeModel";

export const CollectionTypeApi = new class CollectionTypeApi extends ApiBase<CollectionTypeModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/collections-type' });